type TConfig = {
  common: string[];
  feature: string;
};

export const playButtonTranslationConfig: TConfig = {
  common: ['Common.VisitGame'],
  feature: 'Feature.ExperienceDetails'
};

export default playButtonTranslationConfig;
